/* Sude Premium Kit v1.1 */
document.addEventListener('DOMContentLoaded', function () {
  document.documentElement.setAttribute('data-sude-product-cards', 'true');

  document.querySelectorAll('[data-sude-before-after]').forEach(function (section) {
    var range = section.querySelector('.sude-ba__range');
    var after = section.querySelector('.sude-ba__after');
    var line = section.querySelector('.sude-ba__line');
    var handle = section.querySelector('.sude-ba__handle');
    if (!range || !after || !line || !handle) return;

    function update() {
      var value = Number(range.value || 50);
      after.style.clipPath = 'inset(0 ' + (100 - value) + '% 0 0)';
      line.style.left = value + '%';
      handle.style.left = value + '%';
      range.setAttribute('aria-valuenow', String(value));
    }
    range.addEventListener('input', update);
    update();
  });
});

/* Sude Premium Kit v1.1 - Shuffle / Video Shopping Feed */
(function () {
  function initShuffle(root) {
    if (!root || root.dataset.sudeShuffleReady === 'true') return;
    root.dataset.sudeShuffleReady = 'true';

    var feed = root.querySelector('.sude-shuffle__feed');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sude-shuffle-slide]'));
    var autoplay = root.dataset.autoplay === 'true';
    var autoAdvance = root.dataset.autoadvance === 'true';
    if (!feed || !slides.length) return;

    function pauseOtherVideos(activeSlide) {
      slides.forEach(function (slide) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (slide !== activeSlide) {
          video.pause();
          slide.classList.remove('is-active');
        }
      });
    }

    function activate(slide) {
      if (!slide) return;
      pauseOtherVideos(slide);
      slide.classList.add('is-active');
      var video = slide.querySelector('video');
      if (!video) return;
      if (video.duration && isFinite(video.duration)) {
        slide.style.setProperty('--sude-video-duration', video.duration + 's');
      }
      if (autoplay) {
        video.play().catch(function () {});
      }
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.65) activate(entry.target);
      });
    }, { root: feed, threshold: [0.65, 0.85] });

    slides.forEach(function (slide, index) {
      observer.observe(slide);
      var video = slide.querySelector('video');
      var sound = slide.querySelector('[data-sude-sound]');

      if (video) {
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.addEventListener('loadedmetadata', function () {
          if (video.duration && isFinite(video.duration)) slide.style.setProperty('--sude-video-duration', video.duration + 's');
        });
        video.addEventListener('ended', function () {
          if (!autoAdvance) return;
          var next = slides[index + 1] || slides[0];
          next.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
        slide.addEventListener('click', function (event) {
          if (event.target.closest('a, button')) return;
          if (video.paused) video.play().catch(function () {}); else video.pause();
        });
      }

      if (sound && video) {
        sound.addEventListener('click', function () {
          video.muted = !video.muted;
          sound.setAttribute('aria-pressed', String(!video.muted));
          sound.setAttribute('aria-label', video.muted ? 'Sesi aç' : 'Sesi kapat');
          if (video.paused) video.play().catch(function () {});
        });
      } else if (sound) {
        sound.hidden = true;
      }
    });

    root.querySelectorAll('[data-sude-quick-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        var variantId = button.dataset.variantId;
        if (!variantId || button.disabled) return;
        var initialText = button.textContent;
        button.classList.add('is-loading');
        button.textContent = 'Ekleniyor...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Sepete eklenemedi');
            return response.json();
          })
          .then(function () {
            button.classList.remove('is-loading');
            button.classList.add('is-added');
            button.textContent = 'Sepete Eklendi';
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(function () {
              button.classList.remove('is-added');
              button.textContent = initialText;
            }, 1800);
          })
          .catch(function () {
            button.classList.remove('is-loading');
            button.textContent = 'Tekrar Dene';
            setTimeout(function () { button.textContent = initialText; }, 1800);
          });
      });
    });

    activate(slides[0]);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sude-shuffle]').forEach(initShuffle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('[data-sude-shuffle-slide]');
    if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });
})();
